
import { CSSProperties, defineComponent } from 'vue'

import { nextButton, lastButton, correctAnswer, wrongAnswer } from '@/textConfig'
import store from '@/store'

export default defineComponent({
  data: function () {
    return {
      buttonText: nextButton,
      result: correctAnswer as typeof correctAnswer & { description: string },
      state: 'back' as 'back' | 'front' | 'fadein' | 'fadeout',
      zIndex: 1,
    }
  },
  computed: {
    buttonClass() {
      if (store.getters.isAllAnswered) {
        return { button: true, solidButton: true }
      } else {
        return { button: true, transButton: true }
      }
    },
    buttonStyle(): CSSProperties {
      if (this.isButtonDisabled) {
        return {}
      }
      return { cursor: 'pointer' }
    },
    isButtonDisabled(): boolean {
      return this.state === 'back' || this.state === 'fadein' || this.state === 'fadeout'
    },
    boxShadow(): string {
      if (this.zIndex === 2) {
        return '0 5px 30px rgba(25, 60, 92, 0.03)'
      } else {
        return 'none'
      }
    },
    thumbContainerClass(): Record<string, boolean> {
      if (this.result.isCorrect) {
        return { 'thumb-container-correct': true }
      } else {
        return { 'thumb-container-wrong': true }
      }
    },
    resultStyle(): CSSProperties {
      return { zIndex: this.zIndex, boxShadow: this.boxShadow }
    },
    resultClass(): Record<string, boolean> {
      if (this.state === 'back') {
        return { back: true }
      } else if (this.state === 'front') {
        return { front: true }
      } else if (this.state === 'fadein') {
        return { fadein: true }
      } else if (this.state === 'fadeout') {
        return { fadeout: true }
      } else {
        return {}
      }
    },
  },
  methods: {
    confirm() {
      store.dispatch('confirm')
      this.fadeOut()
    },
    fadeOut() {
      this.state = 'fadeout'
      setTimeout(() => {
        this.zIndex = 1
        setTimeout(() => (this.state = 'back'), 100)
      }, 500)
    },
    fadeIn() {
      this.state = 'fadein'
      setTimeout(() => {
        this.zIndex = 2
        setTimeout(() => (this.state = 'front'), 100)
      }, 500)
    },
  },
  mounted() {
    store.subscribe((mutation) => {
      if (mutation.type === 'answer') {
        const description = store.getters.question.description
        const answer = mutation.payload ? correctAnswer : wrongAnswer
        this.result = { description, ...answer }
        this.buttonText = store.getters.isAllAnswered ? lastButton : nextButton
        this.fadeIn()
      }
    })
  },
})
